export const KeyHeader = {
    AUTHORIZATION: 'authorization',
    LANG: 'lang',
};
